import { Table, TableContainer } from '@ksyos/design-system';
import type { EpisodeCategory } from '@common/enums';
import type { SortDirection } from '../../../../../utils/sortDirection';
import type { IEmploymentAndServiceRights } from '../ServiceOrganizationPractitioners';
import { PractitionerTableHead } from './ServiceOrganizationPractitionersTableHead';
import { PractitionerTableBody } from './ServiceOrganizationPractitionerTableBody';

interface IPractitionerTableContainerProps {
    employments: IEmploymentAndServiceRights[];
    episodeCategory: EpisodeCategory;
    index: number;
    partitionEmployments: IEmploymentAndServiceRights[];
    setEmployments: React.Dispatch<React.SetStateAction<IEmploymentAndServiceRights[]>>;
    setSortDirection: React.Dispatch<React.SetStateAction<SortDirection>>;
    sort: (
        employmentAndServiceRights: IEmploymentAndServiceRights[],
        direction: SortDirection,
        sortOn: string
    ) => IEmploymentAndServiceRights[];
    sortDirection: SortDirection;
    sortKey: string;
}

export function PractitionerTableContainer(props: Readonly<IPractitionerTableContainerProps>) {
    const {
        index,
        setEmployments,
        sort,
        setSortDirection,
        sortDirection,
        employments,
        partitionEmployments,
        episodeCategory,
        sortKey,
    } = props;

    return (
        <TableContainer>
            <Table>
                <PractitionerTableHead
                    employments={employments}
                    index={index}
                    setEmployments={setEmployments}
                    setSortDirection={setSortDirection}
                    sort={sort}
                    sortDirection={sortDirection}
                    sortKey={sortKey}
                />
                <PractitionerTableBody
                    employments={employments}
                    episodeCategory={episodeCategory}
                    partitionEmployments={partitionEmployments}
                />
            </Table>
        </TableContainer>
    );
}
